const Footer = () => {
  return (
    <footer className="py-12 px-0 bg-background border-t border-border relative z-20 mt-auto">
      <div className="max-w-[1400px] mx-auto text-center px-[5%]">
        <p className="text-muted-foreground">© {new Date().getFullYear()} Christian Fiebig. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
